import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import SecurityIcon from '@mui/icons-material/Security';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';

const GRADIENT = 'linear-gradient(315deg, #17dddd 0%, #1760d3 74%)';

/**
 * Primary checkout panel — amount, plan badge, Paystack CTA, trust cues.
 */
export default function PricingCheckoutCard({
    planName,
    amountDisplay,
    periodLabel,
    summaryLine,
    discountNote,
    payButton,
    disabled,
}) {
    return (
        <Box
            sx={{
                borderRadius: 3,
                overflow: 'hidden',
                mb: 3,
                boxShadow: '0 12px 40px rgba(23, 96, 211, 0.22)',
            }}
        >
            <Box
                sx={{
                    background: GRADIENT,
                    color: '#fff',
                    px: { xs: 2.5, sm: 3 },
                    py: 3,
                    textAlign: 'center',
                }}
            >
                <Chip
                    label={`${planName} plan`}
                    size="small"
                    sx={{
                        bgcolor: 'rgba(255,255,255,0.2)',
                        color: '#fff',
                        fontWeight: 700,
                        mb: 1.5,
                        border: '1px solid rgba(255,255,255,0.35)',
                    }}
                />
                <Typography
                    component="div"
                    sx={{
                        fontSize: { xs: '2rem', sm: '2.35rem' },
                        fontWeight: 800,
                        lineHeight: 1.1,
                        letterSpacing: '-0.02em',
                    }}
                >
                    GHC {amountDisplay}
                    <Typography
                        component="span"
                        sx={{ fontSize: '1rem', fontWeight: 600, opacity: 0.9, ml: 0.5 }}
                    >
                        / {periodLabel}
                    </Typography>
                </Typography>
                {summaryLine ? (
                    <Typography variant="body2" sx={{ mt: 1.25, opacity: 0.92, lineHeight: 1.5, maxWidth: 420, mx: 'auto' }}>
                        {summaryLine}
                    </Typography>
                ) : null}
                {discountNote ? (
                    <Typography
                        variant="caption"
                        sx={{
                            display: 'block',
                            mt: 1,
                            px: 1.5,
                            py: 0.5,
                            bgcolor: 'rgba(255,255,255,0.15)',
                            borderRadius: 1,
                            maxWidth: 400,
                            mx: 'auto',
                        }}
                    >
                        {discountNote}
                    </Typography>
                ) : null}

                <Box sx={{ mt: 2.5, opacity: disabled ? 0.55 : 1, pointerEvents: disabled ? 'none' : 'auto' }}>
                    {payButton}
                </Box>

                <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="center"
                    flexWrap="wrap"
                    sx={{ mt: 2.5, pt: 2, borderTop: '1px solid rgba(255,255,255,0.25)' }}
                >
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                        <CreditCardIcon sx={{ fontSize: 16, opacity: 0.9 }} />
                        <Typography variant="caption" sx={{ opacity: 0.9 }}>
                            Card & MoMo
                        </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                        <SecurityIcon sx={{ fontSize: 16, opacity: 0.9 }} />
                        <Typography variant="caption" sx={{ opacity: 0.9 }}>
                            Secure Paystack
                        </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                        <PhoneAndroidIcon sx={{ fontSize: 16, opacity: 0.9 }} />
                        <Typography variant="caption" sx={{ opacity: 0.9 }}>
                            Instant activation
                        </Typography>
                    </Stack>
                </Stack>
            </Box>
        </Box>
    );
}
